export default __webpack_public_path__ + "static/media/iotchain2.bc18baed.png";